var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _circle, _g, _circle2, _path11, _path12, _path13, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAddressNothing = function SvgAddressNothing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 120 120"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#addressNothing_svg__a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F0F1F2",
    d: "M110.184 73.993c1.744 1.754 3.439 3.578 5.261 5.254 1.182 1.092 1.201 1.814 0 2.964-7.732 7.41-16.53 13.162-26.567 16.789-25.627 9.271-49.994 6.493-72.889-8.317-3.798-2.456-7.092-5.713-10.629-8.57-1.114-.906-1.153-1.627-.077-2.67 3.73-3.657 7.392-7.38 11.045-11.115.97-.975 1.638-1.102 2.723-.068 7.848 7.41 16.975 12.538 27.497 14.838 20.191 4.427 38.26-.087 53.986-13.668 2.732-2.36 2.693-2.399 5.222.126l4.418 4.446z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "addressNothing_svg__b",
    width: 208,
    height: 113,
    x: -48,
    y: -8,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F0F1F2",
    d: "M60.612 104.616c-25.071 0-43.705-12.196-48.787-16.94l-59.524-50.185L60.61-8 159.5 32l-48.746 54.999c-16.601 14.229-40.316 17.617-50.142 17.617"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#addressNothing_svg__b)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M61.57 84.857v22.5l25.715-2.571L80.857 81z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4F4F4",
    d: "m80.857 81 6.428 23.786L116.214 108 99.499 85.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M6.285 108 23 84.214 42.928 81l-7.714 23.786z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4F4F4",
    d: "m42.928 81-7.714 23.786 26.357 2.571v-22.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#DEE2E9",
    d: "M61.596 78.971v29l27.619-3.314L82.31 74z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#CFD3DB",
    d: "m82.31 74 6.905 30.657 31.072 4.143-17.953-29z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#DEE2E9",
    d: "m2.215 108.8 17.952-30.657L41.572 74l-8.286 30.657z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#CFD3DB",
    d: "m41.573 74-8.286 30.657 28.31 3.314v-29z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 64,
    cy: 84,
    fill: "#CDD2DC",
    opacity: 0.7,
    rx: 16,
    ry: 3,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#E0E3EC",
    d: "M62.978 20.434c4.838 0 9.333 1.384 13.069 3.758.463 5.896 4.336 10.832 9.647 12.841.495 1.795.76 3.678.761 5.62 0 4.712-1.555 9.07-4.195 12.666-.115.185-.234.382-.381.569L65.89 74.942c-.802 1.001-1.85 1.477-2.909 1.477-1.057 0-2.115-.481-2.912-1.477l-15.994-19.05c-.158-.18-.267-.382-.398-.59-2.629-3.59-4.178-7.953-4.178-12.648 0-12.288 10.522-22.22 23.478-22.22m0 13.333c-5.188 0-9.394 3.978-9.394 8.887 0 4.903 4.206 8.889 9.393 8.889 5.182 0 9.388-3.986 9.393-8.889 0-4.903-4.211-8.887-9.393-8.887"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 38,
    cy: 86.801,
    fill: "#CDD2DC",
    opacity: 0.7,
    rx: 3.5,
    ry: 1,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#6D9AE8",
    d: "M38 71.8c-3.035 0-5.5 2.307-5.5 5.16 0 1.09.363 2.104.979 2.938.03.048.056.095.093.137l3.747 4.423a.87.87 0 0 0 .682.343c.248 0 .494-.11.681-.343l3.746-4.425q.05-.066.09-.132a4.9 4.9 0 0 0 .982-2.94c-.003-2.854-2.464-5.16-5.5-5.16m0 7.224c-1.215 0-2.2-.925-2.2-2.064s.985-2.063 2.2-2.063c1.214 0 2.2.925 2.2 2.063s-.986 2.064-2.2 2.064"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "addressNothing_svg__c",
    width: 74,
    height: 73,
    x: 60,
    y: -13,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 97,
    cy: 23.5,
    r: 36.5,
    fill: "#BDC5D1",
    opacity: 0.7
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#addressNothing_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BDC5D1",
    d: "M62.979 20.436c4.837 0 9.332 1.384 13.068 3.757.464 5.896 4.337 10.833 9.648 12.841.495 1.795.76 3.679.762 5.621 0 4.712-1.555 9.07-4.195 12.666-.115.186-.235.382-.382.569L65.892 74.944c-.802 1.001-1.85 1.477-2.908 1.477s-2.116-.481-2.913-1.477l-15.993-19.05c-.158-.18-.267-.382-.398-.59-2.63-3.59-4.178-7.953-4.178-12.648 0-12.288 10.521-22.22 23.476-22.22m0 13.333c-5.188 0-9.393 3.979-9.393 8.887 0 4.903 4.205 8.889 9.392 8.889 5.182 0 9.39-3.986 9.394-8.889 0-4.903-4.212-8.887-9.394-8.887"
  })))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.3,
    cy: 10.3,
    r: 10.3,
    fill: "#F45149",
    transform: "matrix(-1 0 0 1 101.599 12.8)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M91.413 19.502a1.57 1.57 0 0 1-1.151-.478 1.57 1.57 0 0 1-.478-1.15q0-.674.478-1.134a1.57 1.57 0 0 1 1.15-.478q.674 0 1.134.478.478.46.478 1.133t-.478 1.151a1.51 1.51 0 0 1-1.133.478m-1.328 11.333v-9.934h2.85v9.934z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    stroke: "#231815",
    strokeMiterlimit: 10,
    strokeWidth: 0.513,
    d: "M41.65 67.831s-8.766-17-17.18-17.038c-8.414-.04-1.003 11.51 4.522 7.394S28.59 40.545 20.65 37.8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.52,
    d: "m103 51.8-16 16"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "addressNothing_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h120v120H0z"
  })))));
};
export default SvgAddressNothing;